import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { runInAction } from 'mobx';
import { propertyDecorator } from 'decorating';
import observe from '../observe';
import { isDefined, isNull, isFunction } from '../../utils';
var save = propertyDecorator(function (target, prop, desc) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      storage = _ref.storage,
      _ref$storeName = _ref.storeName,
      storeName = _ref$storeName === void 0 ? function (store) {
    return store.storeName;
  } : _ref$storeName,
      _ref$serializer = _ref.serializer;

  _ref$serializer = _ref$serializer === void 0 ? {} : _ref$serializer;
  var _ref$serializer$load = _ref$serializer.load,
      serializerLoad = _ref$serializer$load === void 0 ? function (data) {
    return JSON.parse(data);
  } : _ref$serializer$load,
      _ref$serializer$save = _ref$serializer.save,
      serializerSave = _ref$serializer$save === void 0 ? function (value) {
    return JSON.stringify(value);
  } : _ref$serializer$save,
      _ref$onLoaded = _ref.onLoaded,
      onLoaded = _ref$onLoaded === void 0 ? function () {} : _ref$onLoaded,
      _ref$onSaved = _ref.onSaved,
      onSaved = _ref$onSaved === void 0 ? function () {} : _ref$onSaved,
      _ref$onInitialized = _ref.onInitialized,
      onInitialized = _ref$onInitialized === void 0 ? function () {} : _ref$onInitialized;

  if (!storage) {
    throw new Error("Storage must be defined");
  }

  var status = new Status();
  return observe(
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref2) {
      var value, store, key, data, _data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = _ref2.newValue;
              store = this;
              key = storageKey(store, storeName, prop); // user modified value while loading; loaded value will be ignored

              if (status.isLoading(key)) {
                status.set(key, Status.Initialized);
              }

              _context.t0 = status.get(key);
              _context.next = _context.t0 === Status.NotInitialized ? 7 : _context.t0 === Status.SettingLoadedValue ? 16 : _context.t0 === Status.Initialized ? 18 : 25;
              break;

            case 7:
              status.set(key, Status.Loading);
              _context.next = 10;
              return storage.getItem(key);

            case 10:
              data = _context.sent;

              // check value exists and property was not modified by user
              if (isExists(data) && status.isLoading(key)) {
                status.set(key, Status.SettingLoadedValue);
                value = serializerLoad.call(store, data);
                runInAction("set ".concat(key, " loaded from storage"), function () {
                  store[prop] = value;
                });
                onLoaded.call(store, store, prop, value);
              }

              status.set(key, Status.Initialized);
              value = store[prop];
              onInitialized.call(store, store, prop, value);
              return _context.abrupt("break", 25);

            case 16:
              status.set(key, Status.Initialized);
              return _context.abrupt("break", 25);

            case 18:
              _data = serializerSave.call(store, value);

              if (_data) {
                _context.next = 21;
                break;
              }

              return _context.abrupt("break", 25);

            case 21:
              _context.next = 23;
              return storage.setItem(key, _data);

            case 23:
              onSaved.call(store, store, prop, value);
              return _context.abrupt("break", 25);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), true)(target, prop, desc);
});
export default save;
export function createDecorator(storage, baseOptions) {
  baseOptions = _objectSpread({
    storage: storage
  }, baseOptions);
  return propertyDecorator(function (target, prop, desc, options) {
    options = _objectSpread({}, baseOptions, options);
    return save(options)(target, prop, desc);
  });
}

function storageKey(store, storeName, property) {
  if (isFunction(storeName)) {
    storeName = storeName.call(store, store);
  }

  if (!storeName) {
    throw new Error("`storeName` must be defined as property in store or passed as option " + "to @save decorator");
  }

  return "".concat(storeName, ":").concat(property);
}

var Status =
/*#__PURE__*/
function () {
  function Status() {
    _classCallCheck(this, Status);

    this.statuses = {};
  }

  _createClass(Status, [{
    key: "set",
    value: function set(key, status) {
      this.statuses[key] = status;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.statuses[key];
    }
  }, {
    key: "isLoading",
    value: function isLoading(key) {
      return this.get(key) === Status.Loading;
    }
  }]);

  return Status;
}();

Status.NotInitialized = undefined;
Status.Loading = 1;
Status.SettingLoadedValue = 2;
Status.Initialized = 3;

function isExists(data) {
  return isDefined(data) && !isNull(data);
}